import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

function Header() {
  const { oktaAuth, authState } = useOktaAuth();

  const handleLogout = async () => {
    await oktaAuth.signOut({
      postLogoutRedirectUri: "https://instacart.okta.com"
    });
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <h1>Cap'n Qurunch - Support User Management</h1>
        {authState?.isAuthenticated && (
          <div className="user-info">
            <span className="user-email">
              {authState.idToken?.claims?.email || 'Admin'}
            </span>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
